import { Injectable } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { HttpClientService }  from './../../../../providers';

@Injectable()
export class FilterService {

  constructor( 
  private httpClientService: HttpClientService) {}


getFilteredData(gridData,searchValue,filteredColumns) {
   
    let data = gridData;
    let filteredData: any;
    let isInitial: boolean = true;
    let filterIndexZero = false;
    if (searchValue.length == 0) {
      filteredData = data;
      return filteredData;
    }

if(data.length>0 && !!!data[0].rowIndex)
{
    let uid: any;
    //create property rowIndex for row numbers to the json object 
    for (var key in data) {
      uid = { 'rowIndex': key };
      data[key] = Object.assign({}, data[key], uid);
    }
}

    for (let i: number = 0; i < filteredColumns.length; i++) {
      if (isInitial) {
        filteredData = data.filter(item =>
          item[filteredColumns[i].toString()].toString().toLowerCase().indexOf(searchValue.toLowerCase()) !== -1
        );
        isInitial = false;
        if(filteredData.length === 0) {
          filterIndexZero = true;
        }
        continue;
      }

      filteredData = filteredData.concat(data.filter(item =>
        item[filteredColumns[i].toString()].toString().toLowerCase().indexOf(searchValue.toLowerCase()) !== -1));

    }

    var uniqueData = {};
    //create unique data based on the property rowIndex 
    for (var key in filteredData) {
      uniqueData[filteredData[key].rowIndex] = filteredData[key];
    }

    filteredData = [];

    for (var key in uniqueData) {
      filteredData.push(uniqueData[key]);
    }

    if(filterIndexZero === true && filteredColumns.length > 1 && filteredData.length > 1) {
      filteredData.forEach( obj => this.renameKey(obj, filteredColumns[1], 'filteredCol'));
      filteredData.sort(function(a,b) {
        if(a.filteredCol > b.filteredCol) return 1;
        if(a.filteredCol < b.filteredCol) return -1;
    })
    filteredData.forEach( obj => this.renameKey(obj, 'filteredCol', filteredColumns[1]));
    }
    // //To remove rowIndex property json object 
    // filteredData = filteredData.filter(function (props) {
    //   delete props.rowIndex;
    //   return true;
    // });

    return filteredData;


  }

  renameKey(obj, oldKey, newKey) {
      obj[newKey] = obj[oldKey];
      delete obj[oldKey];
  }

}
